import { useAdvisor } from '@/components/feature/AdvisorProvider';
import { trackContact } from '@/hooks/usePixel';

export default function ContactSection() {
  const { wapp, phone } = useAdvisor();

  return (
    <section id="contacto" className="relative bg-aa-black-soft py-16 md:py-24 overflow-hidden">
      {/* Gold accent */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-aa-gold/[0.02] to-transparent pointer-events-none" />

      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="label-tag block mb-4">INICIA TU PROYECTO</span>
            <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Contáctanos
            </h2>
            <p className="text-aa-gray-100 text-base md:text-lg max-w-2xl mx-auto">
              Escríbenos directamente por WhatsApp y descubre si tu proyecto califica para nuestro financiamiento estructurado.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12">
            {/* Contact Info */}
            <div className="flex flex-col gap-8">
              <div className="glassmorphism rounded-2xl p-6 md:p-8">
                <h3 className="text-white font-semibold text-lg mb-6">Información de Contacto</h3>
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-aa-gold/10 border border-aa-gold/20 flex-shrink-0">
                      <i className="ri-map-pin-line text-aa-gold" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">Ubicación</p>
                      <p className="text-aa-gray-300 text-sm">Cali, Valle del Cauca, Colombia</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-aa-gold/10 border border-aa-gold/20 flex-shrink-0">
                      <i className="ri-phone-line text-aa-gold" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">Teléfono</p>
                      <p className="text-aa-gray-300 text-sm">{phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-aa-gold/10 border border-aa-gold/20 flex-shrink-0">
                      <i className="ri-mail-line text-aa-gold" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">Email</p>
                      <p className="text-aa-gray-300 text-sm">alianzaandina01@gmail.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-aa-gold/10 border border-aa-gold/20 flex-shrink-0">
                      <i className="ri-time-line text-aa-gold" />
                    </div>
                    <div>
                      <p className="text-white font-medium text-sm">Horario</p>
                      <p className="text-aa-gray-300 text-sm">Lunes a Viernes, 8:00 - 18:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="flex flex-col items-center justify-center">
              <div className="glassmorphism rounded-2xl p-8 md:p-12 text-center w-full">
                <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-aa-gold/10 border border-aa-gold/20">
                  <i className="ri-whatsapp-line text-aa-gold text-4xl" />
                </div>
                <h3 className="text-white font-semibold text-xl md:text-2xl mb-4">
                  Hablemos por WhatsApp
                </h3>
                <p className="text-aa-gray-300 text-sm mb-8 max-w-sm mx-auto leading-relaxed">
                  Contáctanos directamente. Nuestro equipo está listo para evaluar tu proyecto y ofrecerte la mejor estructura financiera.
                </p>
                <a
                  href={wapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackContact}
                  className="inline-flex items-center justify-center gap-3 bg-aa-gold text-aa-black px-8 py-4 rounded-xl font-semibold text-base hover:shadow-gold-glow transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl" />
                  <span>Escríbenos por WhatsApp</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}